<template>
    <div>
        <AppButton @click="toggleModal" btnClass="btn-primary">
            {{ $t('Date Change Audit Log') }}
        </AppButton>

        <AppModal v-model="isOpenModal" size="xl">
            <h2 class="text-3xl mb-5">{{ $t('Date Change Audit Log') }}</h2>
            <div class="row justify-content-between flex-grow-1">
                <vue3-datatable :rows="rows"
                                :columns="columns"
                                :loading="loading"
                                :totalRows="total_rows"
                                :isServerMode="true"
                                :pageSize="params.pagesize"
                                :pageSizeOptions="[25, 50, 100, 200, 500]"
                                :sortable="true"
                                :sortColumn="params.sort_column"
                                :sortDirection="params.sort_direction"
                                @change="changeServer">
                    <template #id="data">
                        <strong>#{{ data.value.id }}</strong>
                    </template>
                    <template #subject_type="data">
                        {{ trimString(data.value.subject_type) }}
                    </template>
                    <template #created_at="data">
                        <div>{{ formatDateTime(data.value.created_at) }}</div>
                    </template>
                </vue3-datatable>
            </div>
        </AppModal>
    </div>
</template>

<script setup>
import AppButton from "@/vue/shared/AppButton.vue";
import AppModal from "@/vue/shared/AppModal.vue";
import Vue3Datatable from '@bhplugin/vue3-datatable';
import {computed, onMounted, ref} from "vue";
import useDates from "@/vue/composables/useDates";
import { trans as $t } from "@/vue/composables/missingTranslations";

const props = defineProps({
    serial: {
        type: String,
        required: true,
    },
});

const isOpenModal = ref(false);
const loading = ref(false);
const params = ({
    current_page: 1,
    pagesize: 25,
    sort_column: 'created_at',
    sort_direction: 'desc',
});

const rows = ref(null);
const total_rows = ref(0);

const { formatDateTime } = useDates("MM/DD/YYYY H:m:s");

const columns = computed(() => {
    return [
        { field: 'email', title: $t('Created By'), hide: false },
        { field: 'source', title: $t('Source'), hide: false },
        { field: 'ventilator_summary_id', title: $t('Ventilator Summary ID'), hide: false },
        { field: 'ventilator_brief_summary_id', title: $t('Ventilator Brief Summary ID'), hide: false },
        { field: 'ventilator_id', title: $t('Ventilator ID'), hide: true },
        { field: 'new_record_date', title: $t('New Date'), hide: false },
        { field: 'old_record_date', title: $t('Old Date'), hide: false },
        { field: 'created_at', title: $t('Changed'), hide: false },
    ]
});

const getData = async function() {
    try {
        loading.value = true;

        const urlParams = new URLSearchParams()

        urlParams.append("serial", props.serial);
        urlParams.append("page", params.current_page);
        urlParams.append("limit", params.pagesize);
        urlParams.append("orderBy", params.sort_column);
        urlParams.append("orderDir", params.sort_direction);

        const response = await axios.get(`/api/machines/device/date-change-log?${urlParams}`);

        rows.value = response.data?.data;
        total_rows.value = response?.data?.total;
    } catch {}

    loading.value = false;
}

const trimString = (str) => {
    const lastSlashIndex = str.lastIndexOf('\\');

    if (lastSlashIndex !== -1) {
        return  str.substring(lastSlashIndex + 1);
    } else {
        console.error("No slash found in the string");
        return str;
    }
};

function toggleModal() {
    isOpenModal.value = !isOpenModal.value;

    if (isOpenModal.value) {
        getData();
    }
}

const changeServer = (data) => {
    params.current_page = data.current_page;
    params.pagesize = data.pagesize;
    params.sort_column = data.sort_column;
    params.sort_direction = data.sort_direction;

    getData();
};

// onMounted(() => {
//     getData();
// });
</script>

<style scoped>

</style>
